module.exports = __webpack_public_path__ + "img/logo_internship_alumnus.741076da.png";